module.exports = __webpack_public_path__ + "img/change_pin_border.572b4287.svg";